var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D2F64F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72238 5.50794C8.05036 3.12185 10.2522 1.39441 12.8413 0.700667L14.4879 0.259466C13.5782 0.0675663 12.6505 -0.017842 11.7248 0.00324116C9.24439 0.89464 7.15752 2.66979 5.84859 5.02163C4.60606 7.25419 2.59847 8.91014 0.224486 9.68225C0.153579 10.0442 0.0994509 10.4088 0.0621046 10.7748C2.88534 9.99695 5.2777 8.1037 6.72238 5.50794ZM0.752045 16.1904C0.635337 15.8766 0.53221 15.5588 0.442661 15.2381L3.66128 14.3756C6.25036 13.6819 8.45223 11.9545 9.78022 9.56837C11.2374 6.95007 13.6589 5.04654 16.5141 4.28148L20.2454 3.28168C20.3261 3.35806 20.406 3.43578 20.485 3.51483C20.677 3.70674 20.861 3.90353 21.0372 4.1048L16.7729 5.24741C14.1839 5.94115 11.982 7.66859 10.654 10.0547C9.19678 12.673 6.77535 14.5765 3.9201 15.3416L0.752045 16.1904ZM3.97885 20.926C3.82114 20.7841 3.66628 20.6372 3.51448 20.4854C3.39174 20.3626 3.27221 20.2379 3.15589 20.1113L7.59291 18.9224C10.182 18.2286 12.3839 16.5012 13.7118 14.1151C15.1691 11.4968 17.5905 9.59328 20.4457 8.82822L23.3353 8.05397C23.445 8.36993 23.5412 8.68956 23.6237 9.01196L20.7046 9.79414C18.1155 10.4879 15.9136 12.2153 14.5856 14.6014C13.1284 17.2197 10.707 19.1232 7.85172 19.8883L3.97885 20.926ZM13.2236 23.9379C12.185 24.0438 11.1352 24.0145 10.1027 23.8501L11.5245 23.4691C14.1136 22.7754 16.3155 21.0479 17.6435 18.6618C19.0195 16.1893 21.2555 14.3542 23.9045 13.5133C23.8568 13.8912 23.7911 14.2672 23.7074 14.64C21.5232 15.4656 19.6833 17.053 18.5172 19.1482C17.3121 21.3135 15.4476 22.9899 13.2236 23.9379Z",
    fill: "#9EB93B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenball);
export default __webpack_public_path__ + "static/media/greenball.49b547514080d182b45c4864e6b982b4.svg";
export { ForwardRef as ReactComponent };